import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import CatalogForm from "components/form/CatalogForm";

import useCatalogForm from "hooks/form/useCatalogForm";

function ModificaCatalogo() {
    const formCatalogHook = useCatalogForm();

    const { buttonUpdate } = formCatalogHook;

    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Catalogo</h1>
                </GridItem>
            </GridRow>

            <CatalogForm formCatalogHook={formCatalogHook} />

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={buttonUpdate}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </>
    );
}

export default ModificaCatalogo;
